import { addNodeTree, handleSaveComponent } from "../editor/component-blocks";

function duplicate(actions, query, id) {
  // If query and actions are not available, return
  if (!query || !actions) {
    return;
  }

  // Get the currently selected node
  id = id ?? query.getEvent("selected").first();

  if (!id) return; // If no node is selected, return

  var node_parent = undefined;
  var node_index = undefined;
  const parents = query.node(query.getEvent("selected").first()).ancestors();
  if (parents && parents.length > 0) {
    node_parent = parents[0];
  }
  if (node_parent) {
    let parentChildrens = query.node(node_parent).childNodes();
    node_index = parentChildrens.indexOf(id);
  }

  const componentContent = handleSaveComponent(id, query);

  // Add new cloned node tree at current index
  if (node_parent !== undefined && node_index !== undefined) {
    if (
      query.node(node_parent).get()?.data?.custom?.slug === "grigora/columns"
    ) {
      if (query.node(node_parent).childNodes()?.length < 8) {
        addNodeTree(componentContent, actions, query, node_parent, node_index);
        actions.setProp(node_parent, (props) => {
          props.columnsCount =
            Number(props.columnsCount ? props.columnsCount : 0) + 1;
        });
      }
    } else {
      addNodeTree(componentContent, actions, query, node_parent, node_index);
    }
  }
}

export default duplicate;
